export default {
  data: ()=>({
    waitResponse: false
  }),
  methods: {
    async sendForm(addr = '', form) {
      const formData = new FormData(form)
      this.waitResponse = true
      let vm = this;
      await fetch(`${process.env.VUE_APP_BACKEND}/${addr}`, {
        method: 'POST',
        body: formData,
        mode: "no-cors",
      }).then(vm.$router.push({name :'RequestSent'})).catch(err=>console.log(err))
      this.waitResponse = false
    }
  },
}